// Open (or create) a database

export { openDB, saveData, loadData };

const DBNAME = "Ziege"

function openDB() {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(DBNAME, 1);

        request.onupgradeneeded = (event) => {
            const db = event.target.result;

            // Create an object store if it doesn't exist
            if (!db.objectStoreNames.contains("store")) {
                db.createObjectStore("store", { keyPath: "id" });
            }
        };

        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
}

// Save data
async function saveData(data) {
    const db = await openDB();

    return new Promise((resolve, reject) => {
        const transaction = db.transaction("store", "readwrite");
        const store = transaction.objectStore("store");

        const request = store.put(data); // put = insert or update

        request.onsuccess = () => resolve();
        request.onerror = () => reject(request.error);
    });
}

// Load data by id
async function loadData(id) {
    const db = await openDB();

    return new Promise((resolve, reject) => {
        const transaction = db.transaction("store", "readonly");
        const store = transaction.objectStore("store");

        const request = store.get(id);

        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
}
